import React from "react";
import Footer from "../../components/Footer";

/**
 * Terms of Service.
 *
 * Required by the A2P 10DLC registration: the carrier reviewer opens the site
 * and checks that a Terms page and a Privacy Policy are both published and
 * reachable. The SMS section below has to stay consistent with the same section
 * in PrivacyPolicy.js and with the consent box on the booking form — the review
 * compares all three, and any disagreement between them reads as a
 * misrepresented opt-in flow.
 *
 * Deliberately says nothing about cancelling mortgages, fees or debt: that
 * wording is read by carriers as debt relief, which is prohibited content.
 */
const Terms = () => {
  return (
    <>
      <div id="terms" style={{ padding: "20px" }}>
        <header
          style={{
            color: "#0c0c0d",
            textAlign: "center",
            fontSize: "40px",
            fontWeight: "bold",
            marginBottom: "60px",
          }}
        >
          Terms of Service
        </header>

        <p>
          These Terms of Service govern your use of the Consumer Protection
          Networks website and services. By accessing our website, requesting a
          consultation, or communicating with us, you agree to these terms. If
          you do not agree, please do not use our services.
        </p>

        <h2>Our Services:</h2>
        <p>
          Consumer Protection Networks provides legal title transfer services
          for timeshare owners. We hold informational sessions and consultations
          at which we review an owner&apos;s situation and explain the options
          available to them. Attending a session or requesting a consultation
          creates no obligation, and nothing on this website is an offer,
          guarantee, or promise of any particular outcome.
        </p>

        <h2>No Legal or Financial Advice:</h2>
        <p>
          The content on this website is provided for general informational
          purposes only. It is not legal, tax, or financial advice, and it does
          not create an attorney-client relationship. Every timeshare agreement
          is different. You should consult a qualified professional about your
          own circumstances before making any decision.
        </p>

        <h2>Eligibility:</h2>
        <p>
          You must be at least 18 years old and legally able to enter into a
          contract to use our services. By using this website you confirm that
          the information you give us is accurate and that you are authorised to
          provide it, including the phone number and email address you submit.
        </p>

        <h2>Appointments and Consultations:</h2>
        <p>
          Appointment times, venues, and availability are confirmed by a member
          of our team and may change. We ask that you tell us as early as you
          can if you cannot attend. Where an appointment requires the attendance
          of a spouse or co-owner, that is stated at the time of booking.
        </p>

        <h2>SMS Communications:</h2>
        <p>
          Text messaging is optional and is never required to book an
          appointment or to use our services. You may opt in to receive text
          messages from Consumer Protection Networks in either of two places:
          the chat widget on this website, or our appointment booking form. In
          both places you are shown two separate consent boxes, each unchecked
          by default, and you may check either, both, or neither. Choosing not
          to check either has no effect on your booking or on the service you
          receive.
        </p>

        <p>
          The first box covers messages about your appointment and your case:
          confirmations, reminders, rescheduling notices, service and case
          updates, and replies relating to an enquiry you have already made. The
          second box covers promotional and marketing messages, such as new
          event dates near you and offers on our services. Checking the first
          box does not opt you in to the second. Message frequency varies.
          Message and data rates may apply.
        </p>

        <p>
          You can stop the messages at any time by replying{" "}
          <strong>STOP</strong> to any message you receive from us. We will send
          one confirmation, after which you will receive no further texts. Reply{" "}
          <strong>HELP</strong> to any message, or email us at{" "}
          <a href="mailto:clientservices@consumerprotectionnetworks.com">
            clientservices@consumerprotectionnetworks.com
          </a>
          , for help with our messaging program. Opting out of text messages
          does not stop us contacting you by email or telephone about an
          appointment you have booked.
        </p>

        <p>
          Carriers are not liable for delayed or undelivered messages. For
          questions about your text or data plan, please contact your wireless
          provider.
        </p>

        <h2>Your Information:</h2>
        <p>
          Our handling of the information you give us is described in our{" "}
          <a href="/PrivacyPolicy">Privacy Policy</a>, which forms part of these
          terms. In particular, we do not sell, rent, or share mobile numbers or
          SMS opt-in data with third parties or affiliates.
        </p>

        <h2>Acceptable Use:</h2>
        <p>
          You agree not to use this website to submit false information, to
          submit a phone number or email address that is not yours, to interfere
          with the operation of the site, or to attempt to gain unauthorised
          access to any part of it or to any account.
        </p>

        <h2>Intellectual Property:</h2>
        <p>
          The content, design, text, graphics, and logos on this website belong
          to Consumer Protection Networks and may not be copied, reproduced, or
          redistributed without our written permission.
        </p>

        <h2>Limitation of Liability:</h2>
        <p>
          To the fullest extent permitted by law, Consumer Protection Networks
          is not liable for any indirect, incidental, or consequential damages
          arising out of your use of this website. The website is provided on an
          &quot;as is&quot; basis without warranties of any kind.
        </p>

        <h2>Changes to These Terms:</h2>
        <p>
          We may update these Terms of Service at any time. Any changes will be
          posted on this page. Continuing to use the website after a change
          means you accept the updated terms.
        </p>

        <h2>Contact Us:</h2>
        <p>
          Consumer Protection Networks
          <br />
          96 Beach Walk Blvd, Ste 1255, Conroe, TX 77304
          <br />
          <a href="mailto:clientservices@consumerprotectionnetworks.com">
            clientservices@consumerprotectionnetworks.com
          </a>
        </p>
      </div>

      <Footer />
    </>
  );
};

export default Terms;
